/**
 * The PDP filters a product card links through to from a collection type, each
 * named for the query param that carries it.
 */
export const COLLECTION_FILTERS = {
  sale: "sale",
  contract: "contract",
};

// In order of precedence
const COLLECTION_FILTER_PARAMS = [
  COLLECTION_FILTERS.sale,
  COLLECTION_FILTERS.contract,
];

/**
 * @param {string} search a URL's query string
 * @returns {?string} the COLLECTION_FILTERS value it carries, if any
 */
export function collectionFilterFromSearch(search) {
  const params = new URLSearchParams(search);

  return COLLECTION_FILTER_PARAMS.find((param) => params.has(param)) || null;
}

/**
 * Copies the collection filter params from one query string onto a URL.
 *
 * @param {URL} url updated in place
 */
export function carryCollectionFilterParams(search, url) {
  const params = new URLSearchParams(search);

  COLLECTION_FILTER_PARAMS.forEach((param) => {
    if (params.has(param)) url.searchParams.set(param, params.get(param));
  });
}

/**
 * Hands a collection filter to markup rendered without one — Liquid can't read
 * the query string it was linked with. Reaches the product options forms and
 * the morph that re-renders them, and the PDP links marked
 * `data-collection-filter-link`.
 *
 * @param {ParentNode} root searched along with its top-level children
 */
export function applyCollectionFilter(root, filter) {
  if (!filter) return;

  root
    .querySelectorAll("product-form-options, product-page-morph")
    .forEach((element) => element.setAttribute("collection-filter", filter));

  root.querySelectorAll("a[data-collection-filter-link]").forEach((link) => {
    const href = link.getAttribute("href");

    if (new URL(href, window.location.origin).searchParams.has(filter)) return;

    // Bare, to match the product card's own links
    link.setAttribute(
      "href",
      `${href}${href.includes("?") ? "&" : "?"}${filter}`,
    );
  });
}
